// extracted by mini-css-extract-plugin
export default {"container":"styles_container__W+AbE","footnote":"styles_footnote__hVaaV","grayText":"styles_grayText__IDe+W","tableWrapper":"styles_tableWrapper__6fmoY"};